import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const DoctorsPage = lazy(() => import('../pages/doctors/page'));
const CoachesPage = lazy(() => import('../pages/coaches/page'));
const LifeDesignPage = lazy(() => import('../pages/courses/life-design/page'));
const SexEducationPage = lazy(() => import('../pages/courses/sex-education/page'));
const WellbeingLeaderPage = lazy(() => import('../pages/courses/wellbeing-leader/page'));
const ExecutiveTrainingPage = lazy(() => import('../pages/courses/executive-training/page'));
const BookingPage = lazy(() => import('../pages/booking/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const MyPage = lazy(() => import('../pages/mypage/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const ApplyPage = lazy(() => import('../pages/apply/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const NewsArchivePage = lazy(() => import('../pages/news/page'));
const NewsDetailPage = lazy(() => import('../pages/news/NewsDetailPage'));
const AdminLoginPage = lazy(() => import('../pages/admin/LoginPage'));
const AdminLayout = lazy(() => import('../pages/admin/AdminLayout'));
const AdminDashboardPage = lazy(() => import('../pages/admin/DashboardPage'));
const AdminNewsPage = lazy(() => import('../pages/admin/NewsPage'));
const AdminCategoriesPage = lazy(() => import('../pages/admin/CategoriesPage'));
const AdminUsersPage = lazy(() => import('../pages/admin/UsersPage'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/doctors',
    element: <DoctorsPage />,
  },
  {
    path: '/coaches',
    element: <CoachesPage />,
  },
  {
    path: '/courses/life-design',
    element: <LifeDesignPage />,
  },
  {
    path: '/courses/sex-education',
    element: <SexEducationPage />,
  },
  {
    path: '/courses/wellbeing-leader',
    element: <WellbeingLeaderPage />,
  },
  {
    path: '/courses/executive-training',
    element: <ExecutiveTrainingPage />,
  },
  {
    path: '/booking',
    element: <BookingPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/mypage',
    element: <MyPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/apply',
    element: <ApplyPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/news',
    element: <NewsArchivePage />,
  },
  {
    path: '/news/:id',
    element: <NewsDetailPage />,
  },
  {
    path: '/admin/login',
    element: <AdminLoginPage />,
  },
  {
    path: '/admin',
    element: <AdminLayout />,
    children: [
      { index: true, element: <AdminDashboardPage /> },
      { path: 'news', element: <AdminNewsPage /> },
      { path: 'categories', element: <AdminCategoriesPage /> },
      { path: 'users', element: <AdminUsersPage /> },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
